import { render, staticRenderFns } from "./QuizesForm.vue?vue&type=template&id=31c17558"
import script from "./QuizesForm.vue?vue&type=script&lang=js"
export * from "./QuizesForm.vue?vue&type=script&lang=js"
import style0 from "./QuizesForm.vue?vue&type=style&index=0&id=31c17558&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports